// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sDHPKf {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-0-5, 4px);
}

.JPYhUS {
  color: var(--text-neutral-dark, #1f1f1f);
  font-family: var(--font-family-base, sans-serif);
  font-size: var(--font-size-sm, 12px);
  font-weight: var(--font-weight-medium, 500);
}

.bJfGut {
  position: relative;
  display: flex;
  align-items: center;
  padding: 12px;
  gap: 8px;

  max-width: 236px;
  height: 44px;

  background: #fafafa;
  border: 1px solid #999;
  border-radius: 4px;
}

.TabaKs {
  border: none;
  background: transparent;
  outline: none;
  font-size: 14px;
  text-transform: uppercase;
  flex: 1;
  color: #1f1f1f;
}

.Jyj19n {
  width: 16px;
  height: 16px;
  border: 1px solid #ccc;
  cursor: pointer;
  border-radius: 2px;
}

.Ea753K {
  position: absolute;
  opacity: 0;
  pointer-events: none;
  width: 1px;
  height: 1px;
  border: none;
  padding: 0;
  margin: 0;
}

.P0_JVE {
  opacity: 0.5;
  cursor: not-allowed !important;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/ColorInput/ColorInput.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;EACxC,gDAAgD;EAChD,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,QAAQ;;EAER,gBAAgB;EAChB,YAAY;;EAEZ,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,8BAA8B;AAChC","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-0-5, 4px);\n}\n\n.label {\n  color: var(--text-neutral-dark, #1f1f1f);\n  font-family: var(--font-family-base, sans-serif);\n  font-size: var(--font-size-sm, 12px);\n  font-weight: var(--font-weight-medium, 500);\n}\n\n.colorInputWrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: 12px;\n  gap: 8px;\n\n  max-width: 236px;\n  height: 44px;\n\n  background: #fafafa;\n  border: 1px solid #999;\n  border-radius: 4px;\n}\n\n.colorText {\n  border: none;\n  background: transparent;\n  outline: none;\n  font-size: 14px;\n  text-transform: uppercase;\n  flex: 1;\n  color: #1f1f1f;\n}\n\n.colorSquare {\n  width: 16px;\n  height: 16px;\n  border: 1px solid #ccc;\n  cursor: pointer;\n  border-radius: 2px;\n}\n\n.hiddenColorInput {\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n  width: 1px;\n  height: 1px;\n  border: none;\n  padding: 0;\n  margin: 0;\n}\n\n.disabled {\n  opacity: 0.5;\n  cursor: not-allowed !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `sDHPKf`,
	"label": `JPYhUS`,
	"colorInputWrapper": `bJfGut`,
	"colorText": `TabaKs`,
	"colorSquare": `Jyj19n`,
	"hiddenColorInput": `Ea753K`,
	"disabled": `P0_JVE`
};
module.exports = ___CSS_LOADER_EXPORT___;
